import lity from 'lity';

const getNumberOfSlides = () => {
  if (window.matchMedia('(min-width: 1920px)').matches) {
    return { slidesToShow: 6, slidesToScroll: 1 };
  }

  if (window.matchMedia('(min-width: 1280px)').matches) {
    return { slidesToShow: 5, slidesToScroll: 1 };
  }

  if (window.matchMedia('(min-width: 1000px)').matches) {
    return { slidesToShow: 3, slidesToScroll: 1 };
  }

  if (window.matchMedia('(min-width: 700px)').matches) {
    return { slidesToShow: 2, slidesToScroll: 1 };
  }

  if (window.matchMedia('(min-width: 400px)').matches) {
    return { slidesToShow: 1, slidesToScroll: 1 };
  }

  return { slidesToShow: 1, slidesToScroll: 1 };
};

const init = () => {
  $('.slick-product-tasting-carousel').slick({
    infinite: false,
    speed: 300,
    ...getNumberOfSlides(),
    arrows: true,
    dots: false,
    mobileFirst: true,
    prevArrow: `
    <div class="navigation navigation-product-tasting-prev">
      <button class="navigation__button" id="prev" aria-label="Previous" type="button">
      <svg aria-hidden="true" width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.07063 6.50001L6.60479 8.7526C7.01758 9.11952 7.05476 9.75159 6.68784 10.1644C6.32092 10.5772 5.68885 10.6143 5.27607 10.2474L0.787411 6.2575C0.76889 6.2415 0.750839 6.22471 0.733301 6.20714C0.651207 6.12519 0.586157 6.03203 0.53842 5.93232C0.472805 5.79559 0.440367 5.64762 0.44042 5.50001C0.440512 5.24269 0.539345 4.98649 0.733301 4.79288C0.750845 4.77531 0.768904 4.75851 0.78743 4.7425L5.27607 0.752601C5.68885 0.385683 6.32092 0.422864 6.68784 0.835647C7.05476 1.24843 7.01758 1.8805 6.60479 2.24742L4.07063 4.50001L24.9404 4.50001C25.4927 4.50001 25.9404 4.94773 25.9404 5.50001C25.9404 6.0523 25.4927 6.50001 24.9404 6.50001L4.07063 6.50001Z" fill="black"></path>
      </svg>
    </button>
    </div>
  `,
    nextArrow: `
    <div class="navigation navigation-product-tasting-next">
      <button class="navigation__button" id="next" aria-label="Next" type="button">
      <svg aria-hidden="true" width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9728 4.49999L20.4387 2.2474C20.0259 1.88048 19.9887 1.24841 20.3556 0.835626C20.7225 0.422843 21.3546 0.385662 21.7674 0.752581L26.256 4.7425C26.2746 4.7585 26.2926 4.77529 26.3102 4.79286C26.3923 4.87481 26.4573 4.96797 26.505 5.06768C26.5707 5.20441 26.6031 5.35238 26.603 5.49999C26.6029 5.75731 26.5041 6.01351 26.3102 6.20712C26.2926 6.22469 26.2746 6.24149 26.256 6.2575L21.7674 10.2474C21.3546 10.6143 20.7225 10.5771 20.3556 10.1644C19.9887 9.75157 20.0259 9.1195 20.4387 8.75258L22.9728 6.49999L2.10303 6.49999C1.55074 6.49999 1.10303 6.05227 1.10303 5.49999C1.10303 4.9477 1.55074 4.49999 2.10303 4.49999L22.9728 4.49999Z" fill="black"></path>
      </svg>
    </button>
    </div>
  `,
  });

  $(document).on('click', '[data-my-lightbox]', lity);
};

const destroySlickConfig = () => {
  $('.slick-product-tasting-carousel').slick('unslick');
};

export const initSlickProductTastingGallery = () => {
  document.addEventListener('theme:ready', init);
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('resize', () => {
    destroySlickConfig();
    init();
  });
};
